import React, { useState, useEffect, useContext } from 'react';
import MaterialTable, { MTableToolbar, MTableEditField } from 'material-table';
import Paper from '@material-ui/core/Paper';
import InputLabel from '@material-ui/core/InputLabel';
import MenuItem from '@material-ui/core/MenuItem';
import FormControl from '@material-ui/core/FormControl';
import Select from '@material-ui/core/Select';
import { makeStyles } from '@material-ui/core/styles';
import Checkbox from '@material-ui/core/Checkbox';
import useFetch from '../../CustomHooks/useFetch';
import { GlobalContext } from '../../Contexts/GlobalContext';
import Button from '@material-ui/core/Button';
import ProductsTable from './FoodAndDrinks2__Products';
import AddOrEditProduct from './FoodAndDrinks2__AddOrEditProduct';
import useGuiTranslations from '../MultiLanguage/useGuiTranslations';
import {capitalizeFirstLetter} from '../../Util/StringFunctions';

const useStyles = makeStyles(theme => ({
  formControl: {
    margin: theme.spacing(1),
    minWidth: 120,
  },
  selectEmpty: {
    marginTop: theme.spacing(2),
  },
  root: {
    '& span>button': {
      color: "#5dbcd2",
      fontSize: "60px",
    }
  },
}));

export default function FoodAndDrinks2() {
  const globalContext = useContext(GlobalContext);
  const classes = useStyles();
  const [getCategoriesResponse, getCategoriesHook] = useFetch();
  const [addProductResponse, addProductHook] = useFetch();
  const [categories, setCategories] = React.useState([]);
  const [products, setProducts] = React.useState([]);
  const [selectedCategoryId, setSelectedCategoryId] = React.useState(0);
  const [deleteProductResponse, deleteProductHook] = useFetch();
  const [editProductResponse, editProductHook] = useFetch();
  const [editPictureResponse, editPictureHook] = useFetch();
  const [deletePictureResponse, deletePictureHook] = useFetch();
  const [fileInfo, setFileInfo] = useState(null);
  const [editProductId, setEditProductId] = useState(-1); //0 ise yeni product ekle, -1 ise kapali
  const [translateGui] = useGuiTranslations();

  const fileColumnRender = (rowData) => {

    return (
      <div>
        <img style={{ width: rowData.picture == '' ? '0px' : '50px', height: '50px' }} src={rowData.picture == '' ? null : 'https://' + rowData.picture}></img>
        {rowData.picture != '' ?
          <a style={{ fontSize: '10px' }} href="#" onClick={() => deletePicture(rowData.productId)}>Delete</a>
          : null
        }
      </div>)
  }

  const fileColumnEditRender = (rowInfo) => {
    return (
      <div value="photo">
        <input
          accept="image/*"
          style={{ display: 'none' }}
          id="raised-button-file"
          multiple
          type="file"
          onChange={(e) => onFileChange(e, rowInfo.rowData.productId)}

        />
        <span>{fileInfo == null ? 'mo' : 'degil'}</span>
        <label htmlFor="raised-button-file">
          <Button color="primary" variant="outlined" component="span">
            Picture
          </Button>
        </label>
      </div>
    )
  }

  const [state, setState] = React.useState({
    columns: [
      { title: 'Food or Drink Name', field: 'foodOrDrinkName' },
      { title: 'Price', field: 'price' },
      {
        type: 'boolean',
        title: 'Available',
        field: 'openToSales',
        initialEditValue: true,
      },
    ],
    data: [
    ],
    dataAll: [
      {
        categoryName: 'Drinks',
        products: [
          {
            foodOrDrinkName: 'Cola',
            openToSales: true,
          },
          {
            foodOrDrinkName: 'Ayran',
            openToSales: true,
          },
          {
            foodOrDrinkName: 'Fanta',
            openToSales: false,
          },
        ]
      },
      {
        categoryName: 'Food',
        products: [
          {
            foodOrDrinkName: 'Kofte',
            openToSales: false,
          },
          {
            foodOrDrinkName: 'Kebap',
            openToSales: true,
          },
          {
            foodOrDrinkName: 'Ali Nazik',
            openToSales: true,

          },
        ]
      }

    ],
    categories: ['Drinks', 'Food']
  });

  const deletePicture = (productId) => {
    deletePictureHook(
      {
        url: '/admin/products/' + productId + '/remove-image',
        method: 'PUT',
        addTokenHeader: true,
      }
    )
  }

  useEffect(
    () => {
      //window.gtag('config', 'UA-160225157-2', { 'page_path': '/FoodAndDrinks' });
    }, []
  )

  useEffect(
    () => {
      //if (deletePictureResponse != [])
      //getProducts();
    }, [deletePictureResponse]
  )


  const onFileChange = (event, productId) => {
    setFileInfo(event.target.files[0]);
  }

  function getCategories() {


    getCategoriesHook(
      {
        url: '/admin/categories?PageNumber=1&PageSize=10',
        method: 'GET',
        postData: null,
        addTokenHeader: true,
      }
    )
  }


  /*
    useEffect(
      () => {
        let productArr = [];
        console.log(getProductsResponse);
  
  
        if (getProductsResponse.length != 0 && getProductsResponse) {
          getProductsResponse.products.map(
            (product, index) => {
              productArr.push({ foodOrDrinkName: product.title, openToSales: product.isAvailable, price: product.price, description: product.description, productId: product.id, picture: product.picture })
            }
          )
          setProducts(productArr);
        }
        else {
          setProducts(productArr);
        }
  
        globalContext.dispatchMethod({ type: 'SET_MESSAGE', value: { message: '', showButton: false } });
      }, [getProductsResponse]
    )
  */

  useEffect(
    () => {

      getCategories();

      globalContext.dispatchMethod(
        {
          type: 'SET_MENU_LOCATION',
          value: {
            a: 4,
            b: 6,
          },
        }
      )
    }, []
  );

  useEffect(
    () => {
      let categoryArr = [];
      console.log(getCategoriesResponse);
      if (getCategoriesResponse.length != 0 && getCategoriesResponse) {
        getCategoriesResponse.categories.map(
          (e, index) => {
            if (index == 0) {
              setSelectedCategoryId(e.id);
            }
            categoryArr.push({ categoryName: e.title, openToSales: e.isActive, id: e.id })
          }
        )
        setCategories(categoryArr);
      }

    }, [getCategoriesResponse]
  )

  useEffect(
    () => {
      if (selectedCategoryId != 0) {
        //getProducts();
      }
    }, [selectedCategoryId]
  )




  const addProduct = async (newData) => {
    addProductHook(
      {
        url: '/admin/products',
        method: 'POST',
        addTokenHeader: true,
        postData: {
          title: newData.foodOrDrinkName,
          type: "Food",
          description: newData.description,
          isAvailable: newData.openToSales,
          price: newData.price,
          categoryId: selectedCategoryId
        },
      }
    )
  }

  


  useEffect(
    () => {

      if (editPictureResponse.fileName != null) {
        //getProducts();
      }
    }, [editPictureResponse]
  )

  const deleteProduct = async (oldData) => {
    deleteProductHook(
      {
        url: '/admin/products/' + oldData.productId + '?softDelete=false',
        method: 'DELETE',
        postData: {
          softDelete: 'false',
        },
        addTokenHeader: true,
      }
    )
  }

  useEffect(
    () => {
      //console.log(addCategoryResponse);
      if (deleteProductResponse.length != 0 && deleteProductResponse) {
        //console.log('okmis');
        //getProducts();
      }
    }
    , [deleteProductResponse]
  )
  const comboChange = (e) => {
    console.log(e.target.value);
    setSelectedCategoryId(e.target.value);
    //setValue(e.target.value);
    //setState({...state, data : state.dataAll.filter(a => a.categoryName == e.target.value)[0].products });

  }

  const editProduct = async (newData, oldData) => {
    editProductHook(
      {
        url: '/admin/products/' + oldData.productId,
        method: 'PUT',
        postData: {
          title: newData.foodOrDrinkName,
          description: newData.description,
          isAvailable: newData.openToSales,
          price: newData.price,
          categoryId: selectedCategoryId,
        },
        addTokenHeader: true,
      }
    )

    if (fileInfo != null) {
      let formData = new FormData();
      formData.append('file', fileInfo);
      editPictureHook(
        {
          url: '/admin/products/' + oldData.productId + '/upload-image',
          method: 'PUT',
          postData: formData,
          addTokenHeader: true,
          multipart: true,
        }
      )
    }
  }

  useEffect(
    () => {
      //console.log(addCategoryResponse);
      if (editProductResponse.length != 0 && editProductResponse) {
        //console.log('okmis');
        //getProducts();
      }
    }
    , [editProductResponse]
  )

  

  const ProductsCategorySelector = (props) => {
    return (
      <Paper elevation={3} style={{ padding: '10px', marginBottom: '30px' }}>
        <FormControl className={classes.formControl}>
        <InputLabel id="demo-simple-select-label">{capitalizeFirstLetter(translateGui(5))}</InputLabel>
          <Select
            labelId="demo-simple-select-label"
            id="demo-simple-select"
            value={selectedCategoryId}
            onChange={comboChange}
          >
            {categories.map(category =>
              <MenuItem key={category.id} value={category.id}>{category.categoryName}</MenuItem>
            )}
          </Select>
        </FormControl>
      </Paper>
    )
  }



  return (
    <React.Fragment>
      <div className={classes.root}>
        {
          editProductId == -1 ?
            <React.Fragment>
              <ProductsCategorySelector ></ProductsCategorySelector>
              <ProductsTable addProduct={()=> setEditProductId(0)} editProduct={(productId) => setEditProductId(productId)} selectedCategoryId={selectedCategoryId}></ProductsTable>
            </React.Fragment>
            :
            <AddOrEditProduct closeForm={()=> setEditProductId(-1)}  editProductId={editProductId} selectedCategoryId={selectedCategoryId}></AddOrEditProduct>
        }
      </div>
    </React.Fragment>
  );
}

